/**
 * Constantes de movimento do jogador (doc 02, adaptadas). Unidades SI: m, m/s, m/s², s.
 * Ficam aqui (e não em libs/content) porque mudar qualquer uma altera a simulação compartilhada.
 */
export const MOVE = {
  walkSpeed: 4.2,
  sprintSpeed: 6.8,
  /** Teto de velocidade no chão com todos os bônus (doc 02: o Guaraná respeita os 12 m/s). */
  speedCap: 12,
  crouchSpeed: 2.0,
  groundAccel: 45,
  /** Aceleração quando a entrada aponta contra o movimento atual (frenagem ativa). */
  groundBrake: 90,
  /** Desaceleração sem entrada, por segundo (fração da velocidade perdida por s). */
  groundFriction: 10,
  airControl: 0.3,
  shallowWaterFactor: 0.6,

  gravityUp: 22,
  gravityDown: 28,
  terminalVelocity: 45,
  jumpSpeed: 7.4,
  airJumpSpeed: 6.6,
  coyoteTime: 0.1,
  jumpBuffer: 0.12,
  jumpCooldown: 0.25,

  slideMinSpeed: 5,
  slideBoost: 3,
  slideMaxSpeed: 10,
  slideDecel: 5,
  slideEndSpeed: 2.5,
  slideDuration: 1.2,
  slideCooldown: 0.8,

  swimSpeed: 2.8,
  swimSprintSpeed: 4.0,
  swimAccel: 20,
  swimVertical: 2,
  /** Profundidade (nível do mar − pés) a partir da qual o jogador nada. */
  swimDepth: 1.3,

  radius: 0.35,
  height: 1.8,
  crouchHeight: 1.15,
  eyeHeight: 1.62,
  crouchEyeHeight: 1.0,
  /** Sobe degraus/desníveis de até esta altura sem pular. */
  stepHeight: 0.4,
  /** Gruda no chão ao descer desníveis até esta altura (não "voa" morro abaixo). */
  snapDown: 0.45,
  /** tan(46°): até aqui é caminhável. */
  walkableSlope: 1.0355303137905696,
  /** Abaixo disto do mundo, o jogador volta ao último ponto seguro. */
  killY: -50,
  worldLimit: 1020,
} as const;

/**
 * Fôlego (doc 02 §5 e §7): faz parte do estado previsto porque decide se dá para correr, saltar
 * e deslizar. Custos por segundo ou por ação; recuperação depois de um tempo sem gastar.
 */
export const STAMINA = {
  max: 100,
  sprintPerSecond: 12,
  swimSprintPerSecond: 6,
  divePerSecond: 7,
  jump: 8,
  airJump: 12,
  slide: 10,
  regenPerSecond: 18,
  regenDelay: 0.8,
  /** Na superfície da água recupera pela metade. */
  waterRegenFactor: 0.5,
  /** Com a Fome zerada recupera a 40 % (doc 07, J2). */
  starvingRegenFactor: 0.4,
  /**
   * Ao zerar, fica exausto: não corre nem desliza até recuperar esta fração do máximo (sem isso,
   * segurar Shift alternaria correr e andar a cada passo).
   */
  exhaustedUntil: 0.25,
} as const;

/** Comer (doc 02 §13): canal fixo segurando a ação, mais lento e sem correr. */
export const EAT = {
  seconds: 1.4,
  speedFactor: 0.6,
} as const;
